$(document).ready(function() {
    var phoneConfirmId = '#form-consulting-field-phone-confirm';

    $(phoneConfirmId).attr('autocomplete','off');
    $(phoneConfirmId).bind('copy paste', function(e) {
        e.preventDefault();
    });

    var mailConfirmId = '#form-contact-field-mail-confirm';

    $(mailConfirmId).attr('autocomplete','off');
    $(mailConfirmId).bind('copy paste', function(e) {
        e.preventDefault();
    });
});

$(function() {
    $('#form-consulting').on('submit', function(e){

        var valid = false;
        var phoneId = '#form-consulting-field-phone';
        var phone = $(phoneId).val();
        var phoneConfirmId = '#form-consulting-field-phone-confirm';
        var phoneConfirm = $(phoneConfirmId).val();

        if (phone === phoneConfirm)
            valid = true;

        if(!valid) {
            e.preventDefault();

            $(phoneConfirmId).closest('.form-group').addClass('has-error');
            $(phoneConfirmId).siblings('.help-block').remove();
            $('<div class="help-block">Telefonnummern stimmen nicht überein</div>').insertAfter(phoneConfirmId);

            $('html, body').animate({
                scrollTop: $('#form-consulting').offset().top
            }, 500);
        }
    });

    $('#form-contact').on('submit', function(e){

        var valid = false;
        var mailId = '#form-contact-field-mail';
        var mail = $(mailId).val();
        var mailConfirmId = '#form-contact-field-mail-confirm';
        var mailConfirm = $(mailConfirmId).val();

        if (mail === mailConfirm)
            valid = true;

        if(!valid) {
            e.preventDefault();

            $(mailConfirmId).closest('.form-group').addClass('has-error');
            $(mailConfirmId).siblings('.help-block').remove();
            $('<div class="help-block">E-Mail stimmt nicht überein</div>').insertAfter(mailConfirmId);

            $('html, body').animate({
                scrollTop: $('#form-consulting').offset().top
            }, 500);
        }
    });
});



// WEBPACK FOOTER //
// ./Private/JavaScript/Component/FormValidation.js